'use client';
import { useState, useEffect } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

const NAV_LINKS = [
  { num: '01', label: 'Home',             href: '/' },
  { num: '02', label: 'Case Studies',     href: '/case-studies' },
  { num: '03', label: 'Testimonials',     href: '/testimonials' },
  { num: '04', label: 'Pitch Deck',       href: '/pitch' },
  { num: '05', label: 'About',            href: '/about' },
  { num: '06', label: 'Services',         href: '/services' },
  { num: '07', label: 'Start a Project',  href: '/contact', accent: true },
];

const SOCIALS = [
  { label: 'Twitter', href: 'https://x.com/DotSlashLab' },
  { label: 'Instagram', href: 'https://www.instagram.com/dotslashlab/' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/dotslashlab/' },
];

export default function MobileNav() {
  const [open, setOpen] = useState(false);
  const pathname = usePathname();
 
  const isAdmin = pathname.startsWith("/admin");
  const isStatus = pathname.startsWith("/status");
  const isClient = pathname.startsWith("/client");
  const isPrint = pathname.includes("/print");
  const isInvoice = pathname.startsWith("/invoice");

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      document.body.style.overflow = open ? 'hidden' : '';
    }
    return () => { 
      if (typeof window !== 'undefined') {
        document.body.style.overflow = '';
      }
    };
  }, [open]);

  if (isAdmin || isClient || isPrint || isInvoice) return null;

  return (
    <>
      {/* Mobile navbar bar — only visible ≤768px */}

      {/* Mobile navbar bar — only visible ≤768px */}
      <nav className="dsl-mobile-nav" aria-label="Mobile navigation">
        <Link href="/" className="dsl-mob-logo flex items-center">
          <img src="/logo/Primary_Light_Color.svg" alt="DOTSLASHLAB" className="h-12 w-auto dark:hidden" />
          <img src="/logo/Primary_Dark_Color.svg" alt="DOTSLASHLAB" className="h-12 w-auto hidden dark:block" />
        </Link>
        {!isStatus && (
          <button
            className={`dsl-hb-btn${open ? ' open' : ''}`}
            onClick={() => setOpen(v => !v)}
            aria-label={open ? 'Close navigation' : 'Open navigation'}
            aria-expanded={open}
          >
            <span className="dsl-hb-line l1" />
            <span className="dsl-hb-line l2" />
            <span className="dsl-hb-line l3" />
          </button>
        )}
      </nav>

      {/* Full-screen overlay */}
      <div className={`dsl-overlay${open ? ' open' : ''}`} role="dialog" aria-modal="true">
        <div className="dsl-ov-top">
          <span className="dsl-ov-logo flex items-center">
            <img src="/logo/Primary_Light_Color.svg" alt="DOTSLASHLAB" className="h-12 w-auto dark:hidden" />
            <img src="/logo/Primary_Dark_Color.svg" alt="DOTSLASHLAB" className="h-12 w-auto hidden dark:block" />
          </span>
        </div>
        <div className="dsl-ov-tag">Navigation_menu</div>

        <div className="dsl-ov-links">
          {NAV_LINKS.map(link => (
            <Link
              key={link.href}
              href={link.href}
              className="dsl-ov-link"
              onClick={() => setOpen(false)}
            >
              <div className="dsl-link-left">
                <span className="dsl-link-num">{link.num}</span>
                <span className={`dsl-link-name${link.accent ? ' accent' : ''}`}>
                  {link.label}
                </span>
              </div>
              <span className="dsl-link-arrow" style={link.accent ? {color:'#7b6ff0'} : {}}>→</span>
            </Link>
          ))}
        </div>

        <div className="dsl-ov-bottom">
          <div className="dsl-soc-row">
            {SOCIALS.map(s => (
              <a key={s.label} href={s.href} className="dsl-soc-link">{s.label}</a>
            ))}
          </div>
          <Link href="/contact" className="dsl-cta-btn" onClick={() => setOpen(false)}>
            → Start a Project
          </Link>
        </div>
      </div>
    </>
  );
}
